import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneHeader.styl';

Vue.component('BXmakerAuthuserphoneHeader',
    {
        template: `
            <div class="bxmaker-authuserphone-header" >
                <slot /> 
            </div>
        `,
    });